<template>
  <div>
      <div class="p-d-flex p-jc-center p-mb-5 barra-logo">
          <a href="/login">
              <img alt="Logo" src="@/assets/logo.png" />
          </a>
      </div>
      <div class="p-d-flex p-jc-center">
          <p class="text-codigo p-mb-2"><b>401!</b></p>
      </div>
      <div class="p-d-flex p-jc-center">
          <p class="text-help p-mb-2"><b>Ops!</b> Sem autorização para acessar o conteúdo.</p>
      </div>
      <div class="p-d-flex p-jc-center">
        <Button class="p-mb-2" label="Voltar para Home" @click="voltar"/>
      </div>
  </div>
</template>

<script>
export default {
  methods: {
    voltar() {
      location.href = '/';
    }
  }
}
</script>

<style>

  .barra-logo {
    background-color: #4C4F5A;
    padding: 10px;
  }

  .text-help {
    font-size: 25px !important;
  }

  .text-codigo {
    font-size: 50px !important;
    color: #C13928;
  }

</style>